export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_LANG = 'SET_USER_LANG';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_PAGE_BREADCRUMBS = 'SET_PAGE_BREADCRUMBS';
export const SET_ACTIVE_INVITATIONS = 'SET_ACTIVE_INVITATIONS';
export const SET_IS_EXTERNAL_ACCOUNT_COMPLETED = 'SET_IS_EXTERNAL_ACCOUNT_COMPLETED';
